import React, { useState, useEffect } from 'react';
import {
  CardContent, 
  Typography, 
  TextField,
  InputAdornment,
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogActions
} from '@mui/material';
import { useAppContext } from '../context/AppContext';

function Global() {
  // Initialize local state from state
  const { state, actions } = useAppContext();
  const [values, setValues] = useState({
    globalEquity: state.globalEquity || '',
    globalMF: state.globalMF || '',
    globalBonds: state.globalBonds || '',
  });

  // Sync local state with state when state changes
  useEffect(() => {
    setValues({
      globalEquity: state.globalEquity || '',
      globalMF: state.globalMF || '',
      globalBonds: state.globalBonds || ''
    });
  }, [state.globalEquity, state.globalMF, state.globalBonds]);
  
  const handleChange = (field) => (e) => {
    const raw = e.target.value.replace(/,/g, '');
    const value = raw === '' ? '' : parseInt(raw, 10) || 0;
  
    setValues(prev => ({ ...prev, [field]: value }));
    actions.updateFormData(field, value === '' ? 0 : value);
  };
  

  const formatNumber = (num) => {
    return num === '' ? '' : new Intl.NumberFormat('en-IN').format(num);
  };

  return (
    <Box>
      <CardContent>
        <Box sx={{ mb: 2}}>
        <Typography variant='h6' sx={{mb:2, color: 'primary.main'}}>
            Global Financial Investments
          </Typography>
          <Typography variant="body1" component="h2" gutterBottom>
            Global Bonds & Fixed Income
          </Typography>

          <TextField
            // label="Pension"
            placeholder='total value'
            value={formatNumber(values.globalBonds)}
            onChange={handleChange('globalBonds')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>



        <Box sx={{ mt: 2 }}>

          <Typography variant="body1" component="h2" gutterBottom>
          Global Stocks, RSU
          </Typography>
        
          <TextField
            // label="Global Equity"
            placeholder='total value'
            value={formatNumber(values.globalEquity)}
            onChange={handleChange('globalEquity')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>

        <Box sx={{ mt: 2 }}>
        <Typography variant="body1" component="h2" gutterBottom>
           Global Mutual Funds & ETFs 
          </Typography>
          
          <TextField
            // label="fixed income"
            placeholder='total value'
            value={formatNumber(values.globalMF)}
            onChange={handleChange('globalMF')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box>
        
        {/* <Box sx={{ mt: 2 }}>

          <Typography variant="body1" component="h2" gutterBottom>
            Global Pension Funds
          </Typography>

          <TextField
            // label="Pension"
            placeholder='total value'
            value={formatNumber(values.pension)}
            onChange={handleChange('pension')}
            fullWidth
            type="tel"
            inputMode="numeric"
            InputProps={{
              startAdornment: <InputAdornment position="start">₹</InputAdornment>,
            }}
          />
        </Box> */}
      </CardContent>
    </Box>
  );
}

export default Global;